import React, { useState, useEffect } from 'react'
import ErrorBoundary from './components/ErrorBoundary'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Portfolio from './components/portfolio/Portfolio'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const App = () => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Simulate app initialization time
        const timer = setTimeout(() => {
            setIsLoading(false)
        }, 1000)

        return () => clearTimeout(timer)
    }, [])

    if (isLoading) {
        return (
            <div className="app-loading">
                <div className="app-loading__content">
                    <div className="app-loading__spinner"></div>
                    <h3>Loading Portfolio...</h3>
                </div>
            </div>
        )
    }

    return (
        <ErrorBoundary>
            <div className="fade-in">
                <div id="home"></div>
                <ErrorBoundary>
                    <Header />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <Nav />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <About />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <Experience />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <Portfolio />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <Contact />
                </ErrorBoundary>
                
                <ErrorBoundary>
                    <Footer />
                </ErrorBoundary>
            </div>
        </ErrorBoundary>
    )
}

export default App
